var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.775c.345 0 .625.28.625.625v11.825l2.933-2.933a.625.625 0 1 1 .884.883l-4 4a.625.625 0 0 1-.884 0l-4-4a.625.625 0 0 1 .884-.883l2.933 2.933V3.4c0-.345.28-.625.625-.625ZM4.057 8.597a.625.625 0 0 1 .61-.49h4a.625.625 0 1 1 0 1.25H5.168l-2.389 10.75h18.442l-2.389-10.75h-3.499a.625.625 0 0 1 0-1.25h4c.293 0 .547.204.61.49l2.667 12a.625.625 0 0 1-.61.76H2a.625.625 0 0 1-.61-.76l2.667-12Z",
    fill: "currentColor"
  })));
};
export default SvgDownload;